module.exports = __webpack_public_path__ + "img/pause.039b6b03.png";